import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import axios from 'axios';

import 'styles/custom-color.css';
import 'styles/custom-style.css';
import 'styles/custom-mqueries.css';

import { I18nextProvider } from 'react-i18next';
import i18n from 'components/i18n';

import registerServiceWorker from './registerServiceWorker';

import Municipality from 'pages/Municipality';
import Resource from 'pages/Resource'
import ResourceFile from 'pages/ResourceFile.js'

// Enable axios for using JWT
axios.defaults.withCredentials = true;
axios.defaults.headers.common['Access-Control-Allow-Credentials'] = true;
// axios.defaults.headers.common.Accept = 'application/json';
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
axios.defaults.headers.common['Content-Type'] = 'application/json';

ReactDOM.render(<I18nextProvider i18n={i18n}>
  <Router basename="/webapp">
    <Switch>
      <Route path="/:lang/destinos/:slug" component={Municipality} />
      <Route path="/:lang/recursos/:slug" component={Resource} />
    </Switch>
  </Router>
</I18nextProvider>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js